module.exports = __webpack_public_path__ + "app-static/img/rghb.63a48c50.png";